<template>
  <v-container grid-list-md text-xs-center>
    <LoadingDialog v-if="loading" v-model="loading" />
    <v-layout v-else row wrap>
      <BackButton />
      <v-flex xs12 sm3 style="position: fixed">
        <FundingDetailsSidebar
          :activeMenu="activeMenu"
          :status="loanDetails.loan_status_id"
          @changeMenu="activeMenu = $event"
        />
      </v-flex>
      <v-flex xs12 sm9 class="pl-3 bgw" style="position: absolute; right: 0">
        <v-layout row wrap>
          <v-flex xs3>
            <a
              v-if="
                loanDetails &&
                loanDetails.document &&
                loanDetails.document.photo
              "
              :href="`${photoUrl}/${loanDetails.document.photo}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ImgLazyLoad
                class="profileImage"
                :src="`${photoUrl}/${loanDetails.document.photo}`"
              />
            </a>
          </v-flex>
          <v-flex xs9 class="text-left">
            <v-layout row wrap>
              <v-flex sm3>
                <h4>Funding ID :</h4>
              </v-flex>
              <v-flex sm9>
                <v-list-tile-content>
                  <h3>
                    {{ loanDetails && loanDetails.id ? loanDetails.id : "" }}
                  </h3>
                </v-list-tile-content>
              </v-flex>
              <v-flex sm3>
                <h4>Loan Name :</h4>
              </v-flex>
              <v-flex sm9>
                <v-list-tile-content>
                  <h3>
                    {{
                      loanDetails && loanDetails.loan_product_title
                        ? loanDetails.loan_product_title
                        : "-"
                    }}
                  </h3>
                </v-list-tile-content>
              </v-flex>
              <v-flex sm3>
                <h4>Status :</h4>
              </v-flex>
              <v-flex sm9>
                <v-list-tile-content>
                  <h3>
                    {{
                      loanDetails && loanDetails.loan_status_id
                        ? loanStatus(loanDetails.loan_status_id)
                        : ""
                    }}
                  </h3>
                </v-list-tile-content>
              </v-flex>
              <v-flex sm3>
                <h4>User Name :</h4>
              </v-flex>
              <v-flex sm9>
                <v-list-tile-content>
                  <h3>
                    {{
                      loanDetails && loanDetails.name ? loanDetails.name : ""
                    }}
                  </h3>
                </v-list-tile-content>
              </v-flex>
              <v-flex sm3></v-flex>
              <v-flex sm9>
                <v-list-tile-content>
                  <div
                    v-if="loanDetails && loanDetails.borrower_status == 1"
                    class="summary"
                  >
                    <v-icon color="indigo">check_box</v-icon>
                    <span class="ml-1">has active loan</span>
                  </div>
                </v-list-tile-content>
              </v-flex>
              <v-flex sm3>
                <h4>Phone :</h4>
              </v-flex>
              <v-flex sm9>
                <v-list-tile-content>
                  <h3>
                    <Phone
                      v-if="loanDetails && loanDetails.phone"
                      :phone="loanDetails.phone"
                    />
                  </h3>
                </v-list-tile-content>
              </v-flex>
              <v-flex sm3>
                <h4>Credit Score :</h4>
              </v-flex>
              <v-flex sm9>
                <v-list-tile-content>
                  <h3
                    v-if="
                      loanDetails &&
                      loanDetails.credit_score &&
                      loanDetails.credit_score.showing_score
                    "
                  >
                    <CreditScore :creditScore="loanDetails.credit_score" />
                  </h3>
                  <h3 v-else>-</h3>
                </v-list-tile-content>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <br />
        <hr />

        <UserDetailsBasicInfo
          v-if="loanDetails && activeMenu == 1"
          :userData="loanDetails"
        />
        <UserDetailsProfessionalInfo
          v-else-if="
            loanDetails && loanDetails.professional_info && activeMenu == 2
          "
          :professionalInfo="loanDetails"
        />

        <UserDetailsDocuments
          v-else-if="loanDetails && loanDetails.document && activeMenu == 3"
          :documents="loanDetails.document"
        />

        <UserDetailsBankDetails
          v-else-if="loanDetails && activeMenu == 4"
          :bankDetails="loanDetails.bank_detail"
        />

        <UserDetailsOtherContactInfo
          v-else-if="loanDetails && activeMenu == 5"
          :otherContactInfo="loanDetails.other_contact_info"
        />
        <FundingDetailsFundingDetails
          v-else-if="loanDetails && activeMenu == 6"
          :loanDetails="loanDetails"
        />

        <FundingDetailsEmis
          v-else-if="
            loanDetails &&
            loanDetails.emis &&
            loanDetails.loan_status_id > 7 &&
            loanDetails.loan_status_id != 10 &&
            activeMenu == 7
          "
          :emis="loanDetails.emis"
          :fundingId="loanDetails.id"
        />
        <FundingDetailsCreditScore
          v-else-if="loanDetails && activeMenu == 8"
          :creditScore="loanDetails.credit_score"
        />
        <UserDetailsLoanHistory
          v-else-if="loanDetails && activeMenu == 13"
          :userId="loanDetails.user_id"
          @refresh="refresh(13)"
        />

        <FundingDetailsBankStatementData
          v-else-if="
            loanDetails &&
            loanDetails.document &&
            loanDetails.document.files &&
            loanDetails.document &&
            loanDetails.document.files.length > 0 &&
            loanDetails.document.files[0].file_meta &&
            loanDetails.document.files[0].file_meta != 'null' &&
            activeMenu == 9
          "
          :bankStatementData="
            JSON.parse(loanDetails.document.files[0].file_meta)
          "
        />
        <FundingDetailsDownloads
          v-else-if="loanDetails && activeMenu == 10"
          :downloads="loanDetails"
          @changeStatus="initialize($event)"
        />
        <FundingDetailsActions
          v-else-if="
            loanDetails && loanDetails.loan_status_id < 8 && activeMenu == 11
          "
          :status="loanDetails.loan_status_id"
          @changeStatus="initialize($event)"
        />
        <UserDetailsPorichoyNIDData
          v-else-if="
            loanDetails && loanDetails.nid_porichoy && activeMenu == 12
          "
          :userData="loanDetails.nid_porichoy"
        />
        <UserDetailsValidateNID
          v-else-if="
            loanDetails && !loanDetails.nid_porichoy && activeMenu == 12
          "
          :userID="loanDetails.user_id"
          @refresh="refresh(12)"
        />
        <div v-else class="mt-5"><p>No Data Available</p></div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import LoadingDialog from "@/components/Dialogs/LoadingDialog";
  import FundingDetailsSidebar from "@/components/FundingDetailsSidebar";
  import UserDetailsBasicInfo from "@/components/UserDetailsBasicInfo";
  import UserDetailsProfessionalInfo from "@/components/UserDetailsProfessionalInfo";
  import UserDetailsDocuments from "@/components/UserDetailsDocuments";
  import UserDetailsBankDetails from "@/components/UserDetailsBankDetails";
  import UserDetailsOtherContactInfo from "@/components/UserDetailsOtherContactInfo";
  import UserDetailsPorichoyNIDData from "@/components/UserDetailsPorichoyNIDData";
  import UserDetailsValidateNID from "@/components/UserDetailsValidateNID";
  import FundingDetailsFundingDetails from "@/components/FundingDetailsFundingDetails";
  import FundingDetailsEmis from "@/components/FundingDetailsEmis";
  import FundingDetailsCreditScore from "@/components/FundingDetailsCreditScore";
  import UserDetailsLoanHistory from "@/components/UserDetailsLoanHistory";
  import FundingDetailsBankStatementData from "@/components/FundingDetailsBankStatementData";
  import FundingDetailsDownloads from "@/components/FundingDetailsDownloads";
  import FundingDetailsActions from "@/components/FundingDetailsActions";
  import CreditScore from "@/components/CreditScore";
  import BackButton from "@/components/BackButton";
  import HTTP from "@/utils/HTTP";
  import { fundingApplicationUrl } from "@/utils/variables";
  import ImgLazyLoad from "@/components/ImgLazyLoad";
  import Phone from "@/components/Phone";

  export default {
    components: {
      LoadingDialog,
      FundingDetailsSidebar,
      UserDetailsBasicInfo,
      UserDetailsProfessionalInfo,
      UserDetailsDocuments,
      UserDetailsBankDetails,
      UserDetailsOtherContactInfo,
      UserDetailsPorichoyNIDData,
      UserDetailsValidateNID,
      FundingDetailsFundingDetails,
      FundingDetailsEmis,
      FundingDetailsCreditScore,
      UserDetailsLoanHistory,
      FundingDetailsBankStatementData,
      FundingDetailsDownloads,
      FundingDetailsActions,
      CreditScore,
      BackButton,
      ImgLazyLoad,
      Phone,
    },

    data() {
      return {
        loanDetails: [],
        loading: true,
        activeMenu: 1,
        photoUrl: process.env.VUE_APP_PHOTO_URL,
      };
    },

    created() {
      this.initialize();
    },

    watch: {
      $route() {
        this.initialize();
      },
    },

    methods: {
      async initialize(activeMenu = 6) {
        this.loading = true;
        try {
          const { data } = await HTTP().get(
            `${fundingApplicationUrl}/${this.$route.params.id}`
          );
          this.loanDetails = data.data.loanDetails;
          //   this.totalUsers = data.data.total;
          this.activeMenu = activeMenu;
          this.loading = false;
        } finally {
          //   this.loading = false;
        }
      },
      async refresh(activeMenu) {
        await this.initialize();
        this.activeMenu = activeMenu;
      },
      loanStatus(id) {
        switch (id) {
          case 1:
            return "Pending";
          case 2:
            return "Verified";
          case 3:
            return "Rejected";
          case 4:
            return "Processing";
          case 5:
            return "Signed by Investor";
          case 6:
            return "Signed by Investee";
          case 7:
            return "Approved";
          case 8:
            return "Disbursed";
          case 9:
            return "Completed";
          case 10:
            return "Cancelled";
          case 11:
            return "Defaulted";
          default:
            "Not specified";
        }
      },
    },
  };
</script>
<style scoped>
  .profileImage {
    max-width: 100px;
    max-height: 180px;
  }

  .summary i {
    font-size: 14px;
  }

  .summary span {
    font-size: 12px;
  }
</style>
